<template>
    <section id="projects" class="projects-component">
        <div class="container">
            <component :is="projectsContentComponent"></component>
        </div>
    </section>
</template>

<script>
import {mapState} from 'vuex';

export default {
    name: "ProjectsComponent",
    data() {
        return {}
    },
    created() {
        this.projectValidation();
    },
    computed: {
        ...mapState({
            projectsContentComponent: state => state.main.projectsContentComponent
        })
    },
    methods: {
        projectValidation() {
            // if (!this.$store.state.main.projectsContentComponent) {
            //     this.$router.push({name: 'Coding'});
            // }
        },
    },

}
</script>

<style lang="scss" scoped>
#projects.projects-component {
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}

</style>